import qs from 'qs'
import router from './router'
let v = new Vue();
Vue.prototype.$axios = axios;
Vue.prototype.qs = qs;
// 默认配置
axios.defaults.timeout = 120000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'; //配置请求头
// axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://qyds.schools.sh.cn/webcore/api';
// console.log(axios.defaults.baseURL)

axios.defaults.baseURL = '../../api/';
// axios.defaults.baseURL = '../../../api/';
// axios.defaults.baseURL = 'http://192.168.2.90/api/';
function getcookie(name) {
  var strcookie = document.cookie; //获取cookie字符串
  var arrcookie = strcookie.split("; "); //分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == name) {
      return arr[1];
    }
  }
  return "";
}
export default {
  // data{
  //     url:'',//地址必填
  //     params:{},//参数
  //      method:'post',
  //     isshow:true or false, //是否显示加载和成功提示
  //     onUploadProgress:function(){},// 如果需要获取上传进度
  //     onDownloadProgress:function(){},// 如果需要获取下载进度
  //     timeout:'500', // 如果需要单独设置超时
  //     contentType：'application/json;charset=UTF-8',// 如果需要重新设置发送数据的格式
  //     responseType:'json',// 如果需要设置返回数据的格式
  //     iscenter:false,//是否为管理员端的接口(如调用获取短信接口)
  // }
 
  fetch(data) {
  
    // console.log("参数",data)
    // console.log("data.data",data.data)
    // console.log("data.method",data.method)
  
    //默认传递格式为json，用不到qs，如果需要用form表单则需要对post请求用qs序列化参数
    var instance = axios.create(); //此封装需要用到请求时传入内容，请求及响应拦截本应放在export default外面 这样获取不到传入的data  放在里面每次都会执行两次拦截 所以进行创建实例解决此问题
    instance.interceptors.request.use((config) => {
      // console.log("config",config)
      // 调用个人中心服务器接口
      // if(data.iscenter!=undefined){
      //     config.baseURL = 'https://www.idedx.com/api/'
      // }
      // //调用首页中老框架下的接口
      // 如果需要获取上传进度
      instance.defaults.headers['Pragma'] = 'no-cache'
      instance.defaults.headers['Cache-Control'] = 'no-cache'
      if (data.onUploadProgress != undefined) {
        config.onUploadProgress = function (progressEvent) {
          // var complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
          var complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
          data.onUploadProgress(complete)
        }
      }
      // 如果需要获取下载进度
      if (data.onDownloadProgress != undefined) {
        config.onDownloadProgress = function (progressEvent) {
          var complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
          data.onDownloadProgress(complete)
        }
      }
      // 如果需要单独设置超时
      if (data.timeout != undefined) {
        config.timeout = data.timeout
      }
      // 如果需要重新设置发送数据的格式
      if (data.contentType != undefined) {
        instance.defaults.headers.post['Content-Type'] = data.contentType

      }
      // 如果需要d设置返回数据的格式
      if (data.responseType != undefined) {
        config.responseType = data.responseType
      }
      // 如果发送的post请求，发送的数据需要是json字符串
      if (config.method === 'post' && instance.defaults.headers.post['Content-Type'] == 'application/json;charset=UTF-8') {
      
        config.data = JSON.stringify(config.data);
      }
      // 如果发送的post请求，发送的数据需要是form表单，使用qs进行序列化
      if (config.method === 'post' && instance.defaults.headers.post['Content-Type'] == 'application/x-www-form-urlencoded;charset=utf-8') {
        config.data = qs.stringify(config.data);
      }
      // if (config.method === 'put') {
      //   config.data = qs.stringify(config.data);
      // }
      // 如果需要添加请求头内容
      if (getcookie("XSRF-REQUEST-TOKEN") && (!data.isIndex)) {
        config.headers['X-XSRF-TOKEN'] = getcookie("XSRF-REQUEST-TOKEN");
      }
      // console.log(config)
      return config;
    }, (error) => {
      console.log('错误的传参')
      return Promise.reject(error);
    });

    //返回状态判断(添加响应拦截器)
    instance.interceptors.response.use((res) => {
       
      // console.log(res)
      //对响应数据做些事
      // 如果ie9返回数据为空
      // if (res.data == null && res.config.responseType === 'json' && res.request.responseText != null) {
      //     try {
      //         res.data = JSON.parse(res.request.responseText);
      //     } catch (e) {

      //     }
      // }
      // if (res.status === 200) {
      //     return Promise.resolve(res);
      // }
      return res;
    }, (error) => {
      // console.log(error.response.status,'网络异常')
      console.log('网络异常')
      return Promise.reject(error);
    });
    data.url = data.url || ''
    data.method = data.method || 'post'
    data.params = data.params || {}
    data.data = data.params || {}
    data.isshow = data.isshow || 'true'
    data.responseType = data.responseType || 'json'
    // if(data.method=='put'){
     
    //   data.data=dataPut
    //   // console.log("fr",dataPut)
    // }
    // 添加时间搓
    if (data.url.indexOf('?') != -1) {
      data.url = data.url + '&t=' + new Date().getTime()
    } else {
      data.url = data.url + '?t=' + new Date().getTime()
    }

    if (data.method == 'post' ||  data.method == 'put') {
      data.params = {}
    } else {
      data.data = {}
    }
    if (data.isshow == 'true') {
      var loading = v.$loading({
        // target: '#app',
        fullscreen: true,
        text: '加载中...',
        background: "rgba(0, 0, 0, 0.7)",
        lock: true
      });
    }
    // 使用elementui获得加载中
    // let loadingInstance
    // if (!data.isshow) {
    //     loadingInstance = v.$loading.({
    //         target: '#app',
    //         fullscreen: false,
    //         text: '加载中...',
    //         lock: true
    //     });
    // }
    return new Promise((resolve, reject) => {
      instance({
          url: data.url,
          method: data.method,
          params: data.params,
          data: data.data,
        
        }).then(response => {
          if (data.isshow == 'true') {
            loading.close();
          }
          resolve(response);
        })
        .catch((error) => {
          if(error.code === 'ECONNABORTED') {
            if (data.isshow == 'true') {
              loading.close();
            }
            reject(error)
            return;
          }
          if (data.isshow == 'true') {
            loading.close();
          }
          if(!error.response) reject(error);
          let arr = Object.keys(error);
          let errStatus = error.response.status,
            num = Math.floor(errStatus / 100),
            errMsg = '';
          const h = v.$createElement;
          switch (num) {
            case 5:
              switch (errStatus) {
                case 500:
                  errMsg = '对不起，系统失去连接，请稍后再试。';
                  break;
                case 501:
                  errMsg = '对不起，系统失去连接，请稍后再试。';
                  break;
                case 502:
                  errMsg = '对不起，你的程序可能开小差了，请稍后再试。';
                  break;
                case 503:
                  errMsg = '对不起，系统有点繁忙，请稍后再试。';
                  break;
                case 504:
                  errMsg = '对不起，您的网络可能开小差了，请稍后再试。';
                  break;
                case 505:
                  errMsg = '对不起，HTTP协议的版本有点不兼容，请联系管理员。';
                  break;
                default:
                  errMsg = '对不起，系统失去连接，请稍后再试。';
                  break;
              }
              break;
            case 4:
              switch (errStatus) {
                case 400:
                  errMsg = '对不起，你的程序可能累了，请联系管理员或稍后再试。';
                  break;
                case 401:
                  errMsg = '对不起，登录信息失效，请重新登录。';
                  break;
                case 403:
                  errMsg = '对不起，登录信息失效，请重新登录。';
                  break;
                case 404:
                  errMsg = '对不起，您请求的资源失去连接，请联系管理员或稍后再试。';
                  break;
                case 405:
                  errMsg = '对不起，您请求的资源失去连接，请联系管理员或稍后再试。';
                  break;
                default:
                  errMsg = '对不起，客户端可能开小差了，请联系管理员或稍后再试。';
                  break;
              }
              break;
            case 3:
              errMsg = '对不起，您的请求可能在更换，请联系管理员或稍后再试。'
              break;
          }
          if(error.response.data && error.response.data.errmsg) {
            errMsg = error.response.data.errmsg;
          }
          let eles = $('.el-message-box__wrapper'),
          isContinue = 0
          for(let i = 0; i < eles.length; i++) {
            if(eles[i].style.display == 'none') {
              isContinue = isContinue + 1
            }
          }
          if (isContinue == eles.length) {
            v.$msgbox({
              title: '提示',
              message: h('div', null, [
                h('p', null, `${errMsg}`),
                h('p', null, `状态码：${errStatus}`),
              ]),
              callback: function (actions) {
                if (actions == 'confirm') {
                  if (errStatus == 401) {
                    router.push('/login');
                  }
                  return true
                }
              }
            })
          }
          reject(error)
        })
    })
  },
  //错误提示
  tip(text) {
    v.$msgbox.alert(text, '提示', {
      confirmButtonText: '确定',
      callback: function (actions) {
        if (actions == 'confirm') {
          return true
        }
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/http.js